<div class="responsive-card">
  <div class="d-flex justify-content-between align-items-center">
    <span class="responsive-card-title" i18n>Designated Units</span>
    <app-button *ngIf="!(readonly$ | async)" [type]="ButtonTypeEnum.primary" (buttonClick)="openNewUnitModal()" i18n>
      New Designated Unit
    </app-button>
  </div>
  <app-tab-toggle
    [style.margin-top.rem]="0.5"
    [toggleOptions]="toggleOptions$ | async"
    [selectedValue]="selectedFilter$ | async"
    (valueChanged)="setFilter($event)" />
  <hr class="m-0" />
  <div class="data-table-container" [style.margin-top.rem]="0.5">
    <table class="data-table">
      <app-designated-units-table-header />
      <app-table-empty-state *ngIf="showEmptyState$ | async" [config]="emptyStateConfig$ | async" />
      <ng-container *ngIf="!(showEmptyState$ | async)">
        <app-designated-units-table-row
          *ngFor="let unit of (displayedData$ | async) || [].constructor(pageSize$ | async)"
          [isLoading]="isLoading$ | async"
          [unit]="unit"
          (rowClicked)="navigateToUnit(unit)" />
      </ng-container>
    </table>
    <app-table-footer
      [totalCount]="totalCount$ | async"
      [pageSize]="pageSize$ | async"
      [skip]="skip$ | async"
      (skipChanged)="setSkip($event)" />
  </div>
</div>
